import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getImpersonateStop } from '../../../api';

export const adminAuthenticationImpersonateStopGetSlice = createGetAsyncSlice({
	name: 'AdminAuthenticationImpersonateStop',
	receive: true,
	request: false,
	requestHandler: getImpersonateStop,
	retainDataOnRequest: false
});
